DEFAULT_SHOW_DELAY = 1000
DEFAULT_HIDE_DELAY = 100

module.exports = class ToolTipDelayView extends Backbone.View
  showDebounce: null
  hideDebounce: null

  events:
    'mouseenter': 'showToolTip'
    'mouseleave': 'hideToolTip'

  initialize: ({@eventName, @showDelay, @hideDelay}) ->
    @eventName ?= 'showdelayed'
    @showDelay ?= DEFAULT_SHOW_DELAY
    @hideDelay ?= DEFAULT_HIDE_DELAY
    @cacheElem()
    @initToolTipElemHandlers()

  cacheElem: ->
    @$toolTipElem = $ "##{@$el.data 'tooltip-id'}"

  initToolTipElemHandlers: ->
    @$toolTipElem.on 'mouseenter', @showToolTip
    @$toolTipElem.on 'mouseleave', @hideToolTip

  showToolTip: =>
    @hideDebounce = clearTimeout(@hideDebounce) if @hideDebounce
    return if @showDebounce

    @showDebounce = setTimeout (=>
      @$el.trigger @eventName
    ), @showDelay

  hideToolTip: =>
    @showDebounce = clearTimeout(@showDebounce) if @showDebounce
    return if @hideDebounce

    @hideDebounce = setTimeout (=>
      GIG.Tooltip.close @$toolTipElem
    ), @hideDelay

